import { shake256 } from 'js-sha3';

interface SecurityHeader {
    secret: string;
    clientId: string;
    now: Date;
}

export class ApiSecurity {
    public secretHead: SecurityHeader;
    constructor(secret: string, clientId: string) {
        this.secretHead = {
            secret,
            clientId,
            now: new Date(),
        };
    }
    public get(): string {
        return this.hash();
    }
    private setDate(): string {
        const then = this.secretHead.now.toISOString();
        const last = then.lastIndexOf(':');
        return then.substring(0, last);
    }
    private hash(): string {
        const out = shake256.create(512);
        out.update(this.secretHead.clientId);
        out.update(this.secretHead.secret);
        out.update(this.setDate());
        return out.hex();
    }
}
